import { useContext, useEffect, useState } from 'react';
import useWindowSize from '../../../assets/hooks/useWindowSize';
import './PromoCatalog.css';
import { ConfigContext } from '../../../assets/contexts/configContext';
import { getRandomId } from '../../../assets/utils/utils';
import ProductCardHero from '../../Catalog/ProductCardHero/ProductCardHero';
import { CATALOG_MAIN_LINK, DEMO_PRODUCT, WATCHES_CATEGORY_LINK } from '../../../assets/utils/constants';
import mainApi from '../../../assets/api/MainApi';
import { Link, useSearchParams } from 'react-router-dom';
import { DropArrowIcon } from '../../../assets/icons/promoCatalog';
import { motion } from 'framer-motion';
import MiniPreloader from '../../MiniPreloader/MiniPreloader';
import { FiltersIcon } from '../../../assets/icons/icons';
import { FiltersContext } from '../../../assets/contexts/filtersContext';
import FiltersPopup from '../../Catalog/Products/FiltersPopup/FiltersPopup';
const WATCHES_CATEGORY_ID = "676479d4c86afd6a2d54e4b4"
const PRODUCTS_LIMIT = 6

function parse_filters(filters, searchParams) {
    if (!filters || filters.length === 0) return null
    return filters.map((filter) => {
        let valueFromParams = searchParams ? searchParams.get(`filter_${filter._id}`) : null;
        if (valueFromParams) {
            console.log(filter, valueFromParams)

            switch (filter.data_type) {
                case 'range': {
                    const [GTE, LTE] = valueFromParams.split('-').map(Number);
                    return {
                        ...filter,
                        value: [GTE, LTE]
                    };
                }
                case 'bool': {
                    return {
                        ...filter,
                        value: JSON.parse(valueFromParams)
                    };
                }
                case 'string':
                case 'integer': {
                    try {
                        // Попробуем распарсить как массив
                        const parsedValue = JSON.parse(valueFromParams);

                        if (Array.isArray(parsedValue)) {
                            return {
                                ...filter,
                                value: parsedValue
                            };
                        } else {
                            // Если это не массив, добавляем как есть
                            return {
                                ...filter,
                                value: valueFromParams
                            };
                        }
                    } catch (error) {
                        // Если не получилось распарсить как JSON, просто добавим как строку
                        return {
                            ...filter,
                            value: valueFromParams
                        };
                    }
                }
                default: {
                    return null
                }
            }
        } else {
            //   Default value handling
            switch (filter.data_type) {
                case 'range': {
                    const GTE = filter.features.gte;
                    const LTE = filter.features.lte;
                    return {
                        ...filter,
                        value: [GTE, LTE]
                    };
                }
                case 'bool': {
                    return {
                        ...filter,
                        value: filter.filter_type === 'in_stock' ? false : null
                    };
                }
                default: {
                    return filter;
                }
            }
        }
    }).filter((item) => Boolean(item));
}

function PromoCatalog() {
    const { width } = useWindowSize()
    const [searchParams, setSearchParams] = useSearchParams()
    const config = useContext(ConfigContext)
    const { cardTokens, initialConstants } = config
    const { SHOP_ID_FOR_API } = initialConstants
    const {
        cards_in_line,
    } = cardTokens

    const [popups, setPopups] = useState({
        filters: false,
    })
    const [isBrandsOpen, setBrendsOpen] = useState(false)
    const [initCategory, setInitCategory] = useState(null)
    const [products, setProducts] = useState(null)
    const [brands, setBrands] = useState(null)
    const [selectedBrand, setSelectedBrand] = useState(null)
    const [preloaders, setPreloaders] = useState({
        getBrands: true,
        getItems: true,
        getMainCategory: true,
    })

    useEffect(() => {
        setPreloaders(prevValue => ({
            ...prevValue,
            getBrands: true,
        }));
        getItems({ _id: WATCHES_CATEGORY_ID })
        getMainCategory([WATCHES_CATEGORY_LINK])
        mainApi
            .getCategories({
                limit: 25,
                shop_id: SHOP_ID_FOR_API,
                _id: WATCHES_CATEGORY_ID,
            })
            .then((res) => {
                console.log(res.data)
                setBrands(res.data)
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setPreloaders(prevValue => ({
                    ...prevValue,
                    getBrands: false,
                }));
            });
    }, [])

    function getItems({ _id }) {
        const parsedFilters = [];
        searchParams.forEach((value, key) => {
            if (key.startsWith('filter_')) {
                console.log({ key, value });
                const filterId = key.replace('filter_', '');

                try {
                    // Попробуем распарсить как массив
                    const parsedValue = JSON.parse(value);

                    if (Array.isArray(parsedValue)) {
                        parsedFilters.push({
                            filter_id: filterId,
                            data: parsedValue,
                        });
                    } else {
                        // Если это не массив, добавляем как есть
                        parsedFilters.push({
                            filter_id: filterId,
                            data: value,
                        });
                    }
                } catch (error) {
                    // Если не получилось распарсить как JSON, просто добавим как строку
                    parsedFilters.push({
                        filter_id: filterId,
                        data: value,
                    });
                }
            }
        });

        console.log({ parsedFilters });
        setPreloaders(prevValue => ({
            ...prevValue,
            getItems: true,
        }));
        mainApi
            .getItems({
                shop_id: SHOP_ID_FOR_API,
                category: _id ? _id : null,
                limit: PRODUCTS_LIMIT,
                filters: parsedFilters ? parsedFilters : null,
            })
            .then((res) => {
                console.log(res)
                setProducts(res);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setPreloaders(prevValue => ({
                    ...prevValue,
                    getItems: false,
                }));
            });
    }

    const [category, setCategory] = useState(undefined);

    const [filterValues, setFilterValues] = useState(null)

    function getMainCategory(levels) {
        setPreloaders((prevState) => ({
            ...prevState,
            getMainCategory: true,
        }));
        mainApi
            .getCategoriesWithTree({
                shop_id: SHOP_ID_FOR_API,
                data: levels,
            })
            .then((res) => {
                console.log(res)
                const data =
                    res.data.length > 0 ? res.data[res.data.length - 1] : undefined;
                const filters = data.filters ? data.filters.filter((item) => !item.name.startsWith('_') && !(item.name.toLowerCase().indexOf('артикул') >= 0) && !(item.option_name === 'Артикул')) : null
                console.log(data.filters)
                setCategory({
                    _id: data._id,
                    title: data.name,
                    path: res.data,
                    categories: [],
                    filters: filters,
                    published_count: data.published_count,
                });
                setFilterValues(parse_filters(filters, searchParams))
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setPreloaders((prevState) => ({
                    ...prevState,
                    getMainCategory: false,
                }));
            });
    }




    console.log({ category })

    function handleFiltersReset() {
        console.log('RESET', filterValues)
        setFilterValues(parse_filters(category.filters))
        category.filters.forEach((filter) => {
            searchParams.delete(`filter_${filter._id}`);
        });

        // Update the URL with the cleared search params
        setSearchParams(searchParams, { replace: true });

        getItems({ _id: category._id })
    }

    function handleFiltersApply() {
        const parsedValues = filterValues.filter(item => item.value != null).map((item) => {
            console.log(item, item.value)
            switch (item.data_type) {
                case 'range': {
                    if (item.value[0] === item.value[1]) return null
                    return ({ filter_id: item._id, data: `${item.value[0]}-${item.value[1]}` });
                }
                case 'integer': {
                    return ({ filter_id: item._id, data: JSON.stringify(item.value) });
                }
                case 'string': {
                    return ({ filter_id: item._id, data: JSON.stringify(item.value) });
                }
                default: {
                    return ({ filter_id: item._id, data: item.value });
                }
            }
        }).filter((item) => Boolean(item))
        // Add each filter to the search params
        parsedValues.forEach(({ filter_id, data }) => {
            try {
                if (Array.isArray(JSON.parse(data)) && JSON.parse(data).length === 0) {
                    searchParams.delete(`filter_${filter_id}`);
                }
                else searchParams.set(`filter_${filter_id}`, data);
            }
            catch {
                searchParams.set(`filter_${filter_id}`, data);
            }


        });

        // Update the URL with the new search params
        setSearchParams(searchParams, { replace: true });

        console.log('APPLY', parsedValues);
        getItems({ _id: category._id })
    }

    function handleOpenFilterPopup() {
        setPopups(prevValue => ({
            ...prevValue,
            filters: true,
        }))
    }

    function handlePopupClose({ name }) {
        setPopups(prevValue => ({
            ...prevValue,
            [name]: false,
        }))
    }

    function handleSelectBrand(brand) {
        handleFiltersReset()
        if (selectedBrand && brand._id === selectedBrand._id) {
            setSelectedBrand(null)
            setBrendsOpen(false)
            getItems({ _id: WATCHES_CATEGORY_ID })
            getMainCategory([WATCHES_CATEGORY_LINK])
            return
        }
        setSelectedBrand(brand)
        setBrendsOpen(false)
        getItems({ _id: brand._id })
        getMainCategory([WATCHES_CATEGORY_LINK, brand.translit_name])
    }

    useEffect(() => {
        if (!popups.filters) { document.body.style.overflow = 'initial'; }
        else { document.body.style.overflow = 'hidden'; }
    });


    return (

        preloaders.getBrands && preloaders.getItems && preloaders.getMainCategory ?
            <MiniPreloader />
            :
            <div className='promo-catalog'>
                {category ?
                    <FiltersContext.Provider value={{
                        filters: category.filters,
                        handleFiltersReset,
                        handleFiltersApply,
                        filterValues,
                        setFilterValues,
                        handleOpenFilterPopup,
                        isLoading: preloaders.products,
                    }}>
                        <FiltersPopup
                            isOpen={popups.filters}
                            handleClose={handlePopupClose}
                            popupName={'filters'}
                            isApplyActive={true}
                        />
                    </FiltersContext.Provider>
                    : null}

                <h2 className='promo-catalog__title'>Watches</h2>
                <div className='promo-catalog__filters'>
                    {/* <div className='promo-catalog__filters-brands'>
                        <p className='promo-catalog__filters-title promo-catalog__filters-title_brand promo-catalog__filters-title_brand_pc'>Brand</p>
                        <div className='promo-catalog__filters-brands-drop-container'>
                            <button className='promo-catalog__filters-brands-selected' type='button' onClick={() => {
                                setBrendsOpen(prevValue => !prevValue)
                            }}>
                                <p className='promo-catalog__filters-brands-selected-text'>{selectedBrand ? selectedBrand.name : 'Select brand'}</p>
                                <DropArrowIcon
                                    mainClassName={'promo-catalog__filters-brands-selected-arrow'}
                                    fillClassName={'promo-catalog__filters-brands-selected-arrow-fill'}
                                />
                            </button>
                            {isBrandsOpen ?
                                <motion.div
                                    className='promo-catalog__filters-brands-dropdown'
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                >
                                    {brands && brands.length > 0 ?
                                        brands.map((brand, i) => (
                                            <button className={`promo-catalog__filters-brands-dropdown-item ${selectedBrand && brand._id === selectedBrand._id ? 'promo-catalog__filters-brands-dropdown-item_selected' : ''}`} key={`promo-catalog__filters-brands-dropdown-item${i}`} type='button' onClick={() => {
                                                handleSelectBrand(brand)
                                            }}>
                                                {brand.name}
                                            </button>
                                        ))
                                        : null}
                                </motion.div>
                                : null}
                        </div>
                    </div> */}
                    <div></div>
                    <div className='promo-catalog__filters-all'>
                        <p className='promo-catalog__filters-title promo-catalog__filters-title_filters'>Filters</p>
                        <button className='promo-catalog__filters-all-btn' type='button' onClick={handleOpenFilterPopup}>
                            <FiltersIcon mainClassName={'promo-catalog__filters-all-btn-icon'} strokeClassName={'promo-catalog__filters-all-btn-icon-stroke'} />
                        </button>
                    </div>
                </div>
                {preloaders.getItems ?
                    <div className='promo-catalog__items-preloader'>
                        <MiniPreloader />
                    </div>
                    :

                    <div className={`promo-catalog__items promo-catalog__items_cards-in-line-${cards_in_line}`}>
                        {products && products.data && products.data.length > 0 ?
                            products.data.slice(0, 6).map((item, i) => (
                                // i === 0 ?
                                <ProductCardHero
                                    item={item}
                                    key={`promo-catalog_${item._id}products_item_${i}`}
                                />
                                // :
                                // <ProductCard
                                //     item={item}
                                //     key={`promo-catalog_${_id}products_item_${i}`}
                                // />
                            ))
                            :
                            null}

                    </div>
                }
                <div className='promo-catalog__all-line'>
                    <Link className='promo-catalog__all-line-btn'
                        to={`/${CATALOG_MAIN_LINK}/${WATCHES_CATEGORY_LINK}${selectedBrand ? `/${selectedBrand.translit_name}` : ''}`}
                    >
                        View all {category ? category.published_count : ''}
                    </Link>
                </div>
            </div>
    );
}

export default PromoCatalog